import { COLORS } from 'styles/colors'

export const CHART_LEGENDS = [
	{ color: COLORS.success, description: 'Корм доступен' },
	{ color: COLORS.health, description: 'Корм недоступен' },
	{ color: COLORS.error, description: 'Кормовой стол пустой' },
	{ color: COLORS.secondaryFont, description: 'Нет данных' },
]
